import { useAuth } from "../../hooks/useAuth";
import MultiPlaceAdminInvoicesPage from "../multi-place-admin/invoices/InvoicesPage";

export default function Invoices() {
  const { isMultiPlaceAdmin } = useAuth();

  if (isMultiPlaceAdmin) {
    return <MultiPlaceAdminInvoicesPage />;
  }

  return <div>Invoices</div>;
}
